// eslint-disable-next-line internal-rules/no-store-in-composables
import { useStore } from 'vuex';
import { computed, unref } from 'vue';

/**
 * Provides a single interface for cloning a Countable object.
 *
 * @param {Ref} idRef
 * @param {Ref} typeRef page, feature (*not* track event)
 */
export default function (idRef, typeRef) {
    const store = useStore();
    const countable = computed(() => {
        const id = unref(idRef);
        const type = unref(typeRef);
        switch (type) {
            case 'page':
                return store.getters['pages/pageById'](id);
            case 'feature':
                return store.getters['features/featureById'](id);
            case 'trackEvent':
                return store.getters['trackTypes/trackTypeById'](id);
            default:
                return null;
        }
    });

    return {
        countable,
    };
}
